//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            dataList: [],
            imgHeight: 0
        }
    },
    methods: {
        getRecommend() {
            let that = this;
            let searchItem = {
                currentPage: 1,
                pageSize: 20,
                isSuit: 0
            }
            that.$axios.get('/api/v1.0/familyApp/goods', {
                params: searchItem
            }).then(function (response) {
                if(response.status == 200) {
                    var storeGoodsList = response.body.storeGoodsList.map((item) => {
                        item.poster = item.photo;
                        item.goodsName = item.goodsTitle;
                        return item;
                    });
                    that.dataList = storeGoodsList;
                } else if(response.status == 203) {

                }
            })
        },
        toDetail(item) {
            this.$emit('toDetail', item);
        },
        readyBuy(item) {
            this.$emit("readyBuy", item)
        }
    },
    mounted() {
        this.getRecommend();
        this.imgHeight = ($(window).width() - 30)/2;
    }
}



// WEBPACK FOOTER //
// ./src/components/buycar/recommend.vue